import React from "react";
import { Stack, Typography } from "@mui/material";

export const TextBlock = ({ text = [] }: { text?: string[] }) => {
  if (Array.isArray(text) && text.length === 0) return null;
  if (typeof text === "string") return <TextBlock text={[text]} />;

  const parseText = (input: string) => {
    // Split by bold (**text**) and italic (*text*) markers
    const parts = input.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);

    return parts.map((part, idx) => {
      let content = part;
      let isBold = false;
      let isItalic = false;

      if (part.startsWith("**") && part.endsWith("**")) {
        content = part.slice(2, -2);
        isBold = true;
      } else if (part.startsWith("*") && part.endsWith("*")) {
        content = part.slice(1, -1);
        isItalic = true;
      }

      const linkParts = content.split(/(https?:\/\/[^\s]+)/g);
      const processed = linkParts.map((linkPart, i) => {
        if (linkPart.match(/^https?:\/\/[^\s]+$/)) {
          return (
            <a
              key={`${idx}-${i}`}
              href={linkPart}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0097DD", textDecoration: "underline" }}
            >
              {linkPart}
            </a>
          );
        }

        return <React.Fragment key={`${idx}-${i}`}>{linkPart}</React.Fragment>;
      });

      if (isBold) {
        return (
          <strong key={idx} style={{ fontWeight: 600 }}>
            {processed}
          </strong>
        );
      }

      if (isItalic) {
        return (
          <em key={idx} style={{ fontStyle: "italic" }}>
            {processed}
          </em>
        );
      }

      return <React.Fragment key={idx}>{processed}</React.Fragment>;
    });
  };

  return (
    <Stack gap="12px" alignItems="flex-start">
      {text.map((item, index) => {
        if (item.startsWith("**LinkedIn:**") && item.endsWith("Not available"))
          return null;

        return (
          <Typography
            key={index}
            sx={{
              color: "#1F2932",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            {parseText(item)}
          </Typography>
        );
      })}
    </Stack>
  );
};
